<template>
  <div class="row refeicaosel align-center">
    <div class="small-12 medium-4 large-4 columns">
      <a @click="$emit('setRefeicao','almoco')"
          class="refeicaooption"
          :class="{'active': currentRefeicao == 'almoco'}">
          {{ $t("UMA_LANG_SASUMA_REFEICAO_ALMOCO") }}
      </a>
      <a @click="$emit('setRefeicao','jantar')"
          class="refeicaooption"
          :class="{'active': currentRefeicao == 'jantar'}">
          {{ $t("UMA_LANG_SASUMA_REFEICAO_JANTAR") }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props:["currentRefeicao"]
}
</script>

<style lang="scss" scoped>
.refeicaosel{
  margin-top: 50px;
  margin-bottom: 50px;
}

.refeicaosel .columns{
  display: flex;
}

.refeicaooption{
  font-family: "Montserrat";
  flex-direction: row;
  flex: 1;
  padding-bottom: 10px;
  border-bottom: 2px solid #dedee0;
  text-align: center;
  color: #333333;
  font-size: 19px;
}

.refeicaooption.active{
  border-bottom: 3px solid #6eb7ec;
  font-family: "Montserrat SemiBold";
}

@media (max-width: 767px) {

  .refeicaosel {
    margin-top: 25px;
    margin-bottom: 20px;
  }
  
  .refeicaooption {
    font-size: 16px;
  }
}

</style>